// extracted by mini-css-extract-plugin
export default {"SideMenuHeader":"Sidemenu_SideMenuHeader__+fRDP","Sidemenu":"Sidemenu_Sidemenu__Ww2bz","Buttons":"Sidemenu_Buttons__WgC5A","Disabled":"Sidemenu_Disabled__HugrZ"};